export const LANE_COUNT = 3;
export const CANVAS_WIDTH = 400;
export const CANVAS_HEIGHT = 700;
export const LANE_WIDTH = CANVAS_WIDTH / LANE_COUNT;
export const LANE_CENTERS = [
  LANE_WIDTH * 0.5,
  LANE_WIDTH * 1.5,
  LANE_WIDTH * 2.5,
];
export const PLAYER_WIDTH = 40;
export const PLAYER_HEIGHT = 60;
export const PLAYER_Y = CANVAS_HEIGHT - 120;
export const OBSTACLE_WIDTH = 44;
export const OBSTACLE_HEIGHT = 60;
export const OBSTACLE_BASE_SPEED = 3.5;
export const OBSTACLE_SPEED_INCREMENT = 0.0004;
export const OBSTACLE_MAX_SPEED = 14;
export const OBSTACLE_SPAWN_INTERVAL_MS = 1600;
export const OBSTACLE_SPAWN_INTERVAL_MIN_MS = 650;
export const OBSTACLE_SPAWN_ACCELERATION = 0.998;
export const SCORE_PER_SECOND = 10;
export const HIGH_SCORE_KEY = 'lane_blazer_high_score';
export const ROAD_COLOR = 0x1a1a2e;
export const LANE_LINE_COLOR = 0x444466;
export const PLAYER_COLOR = 0x00d4ff;
export const OBSTACLE_COLORS = [0xff4444, 0xff8800, 0xffcc00, 0xff44aa];
export const GRASS_COLOR = 0x1a3a1a;